import React, { useState, useRef, useEffect } from "react";
import { Tabs, Tab, Container } from "react-bootstrap";
import { graphql } from "gatsby";
import SectionTitle from "../../atoms/SectionTitle";
import AnchorID from "../../atoms/AnchorID";
import { getParagraph } from "../../../utils/paragraphHelpers";
import TabView from "./TabView";
import AccordionView from "./AccordionView";
import "./responsiveTabs.scss";

const VIEW_MODE = {
  TABS: "TABS",
  ACCORDION: "ACCORDION",
};

export const ParagraphResponsiveTabs = ({ node }) => {
  const tabRef = useRef(null);
  const [value, setValue] = useState("0");
  const [viewMode, setViewMode] = useState(VIEW_MODE.TABS);
  const [accValue, setAccValue] = useState(0);
  const {
    field_section_id,
    field_component_title,
    field_component_subtitle,
    field_tab_description,
    relationships,
  } = node;

  useEffect(() => {
    handleViewMode();
    window.addEventListener("resize", handleViewMode);
    return () => {
      window.removeEventListener("resize", handleViewMode);
    };
  }, []);

  const handleViewMode = () => {
    if (relationships?.field_tab_item?.length === 1) return;
    if (window.innerWidth <= 991) {
      setViewMode(VIEW_MODE.ACCORDION);
      return;
    }
    const totalWidth = tabRef.current.offsetWidth;
    const tabs = Array.from(tabRef.current.children[0].children);
    const totalTabWidth = tabs.reduce((a, b) => a + Number(b.offsetWidth), 0);
    if (totalTabWidth >= totalWidth) {
      setViewMode(VIEW_MODE.ACCORDION);
      return;
    }
    setViewMode(VIEW_MODE.TABS);
  };

  if (relationships?.field_tab_item?.length === 1) {
    return (
      <div className="grid-acc-tabs">
        {/* <AnchorID id={field_section_id} /> */}

        <Container
          className="general-container grid-acc-tabs__container"
          data-aos="fade-up"
          id={field_section_id}
        >
          <SectionTitle
            titleClassName="grid-acc-tabs__title"
            subtitleClassName="grid-acc-tabs__subtitle"
            title={field_component_title}
            subtitle={field_component_subtitle}
            description={field_tab_description}
          />
          <div className="grid-tabs-margin">
            {relationships?.field_tab_item[0]?.relationships?.field_tab_content?.map(
              getParagraph
            )}
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="grid-acc-tabs">
      {/* <AnchorID id={field_section_id} /> */}
      <Container
        className="general-container grid-acc-tabs__container"
        data-aos="fade-up"
        id={field_section_id}
      >
        <SectionTitle
          titleClassName="grid-acc-tabs__title"
          subtitleClassName="grid-acc-tabs__subtitle"
          title={field_component_title}
          subtitle={field_component_subtitle}
          description={field_tab_description}
        />

        <div ref={tabRef} className="grid-tabs grid-tabs-hidden">
          <Tabs defaultActiveKey={value} onSelect={setValue}>
            {relationships?.field_tab_item?.map((item, key) => (
              <Tab key={key} eventKey={key} title={item?.field_tab_title} />
            ))}
          </Tabs>
        </div>

        {viewMode === VIEW_MODE.TABS && (
          <TabView
            value={value}
            setValue={setValue}
            tabs={relationships?.field_tab_item}
          />
        )}
        {viewMode === VIEW_MODE.ACCORDION && (
          <AccordionView
            accValue={accValue}
            setAccValue={setAccValue}
            tabs={relationships?.field_tab_item}
          />
        )}
      </Container>
    </div>
  );
};

export const fragment = graphql`
  fragment ParagraphResponsiveTabs on paragraph__responsive_tab {
    field_section_id
    field_component_title
    field_component_subtitle
    field_tab_description {
      value
    }
    relationships {
      field_tab_item {
        field_tab_title
        relationships {
          field_tab_content {
            type: __typename
            ...ParagraphRegionalOverview
            ...ParagraphDepartmentBlockPeople
            ...ParagraphRichTextContentBlock
            ...ParagraphMapContentBlock
            ...ParagraphInfographicHeaderLP
            ...ParagraphColumnEqual
            ...ParagraphParagraphTextBlock
            ...ParagraphMediaBeside
            ...ParagraphFlexibleColumn
            ...ParagraphKeyPublications
            ...ParagraphMediaBeside
          }
        }
      }
    }
  }
`;
